/**
 * Resolves on the next animation frame
 * @returns {Promise<number>}
 */
export function nextFrame() {
    return new Promise(resolve => window.requestAnimationFrame(resolve));
}
